import { z } from "zod";

export const projectLiveEventTypeSchema = z.enum([
  "connected",
  "heartbeat",
  "walkthrough_pushed",
  "walkthrough_completed",
  "gate_evaluated",
  "finding_triaged",
]);

export type ProjectLiveEventType = z.infer<typeof projectLiveEventTypeSchema>;

export const projectLiveEventSchema = z.object({
  type: projectLiveEventTypeSchema,
  projectId: z.string(),
  runId: z.string().optional(),
  scenarioName: z.string().optional(),
  verdict: z.unknown().optional(),
  buildId: z.string().optional(),
  timestamp: z.string(),
});

export type ProjectLiveEvent = z.infer<typeof projectLiveEventSchema>;
